/** English (default) translations. All user-visible labels and messages go here. */
export const en = {
  // --- Structure panel ---
  'structure.search.placeholder': 'Search tables / columns…',
  'structure.search.clear': 'Clear search',
  'structure.empty.no_dbml': 'No DBML loaded.',
  'structure.empty.no_matches': 'No matches.',
  'structure.section.columns': 'Columns',
  'structure.section.relations': 'Relations',
  'structure.pk.title': 'Primary key',
  'structure.hide.hide': 'Hide from diagram',
  'structure.hide.show': 'Show in diagram',

  // --- Detail panel ---
  'detail.error.heading': "Couldn't parse this DBML",
  'detail.empty.no_dbml': 'No DBML loaded.',
  'detail.empty.pick_item': 'Pick a table or enum from the list.',
  'detail.empty.schema_info': '{parts} in this schema.',
  'detail.count.table': '{count} table',
  'detail.count.tables': '{count} tables',
  'detail.count.enum': '{count} enum',
  'detail.count.enums': '{count} enums',
  'detail.section.columns': 'Columns',
  'detail.col.name': 'Name',
  'detail.col.type': 'Type',
  'detail.col.flags': 'Flags',
  'detail.col.default': 'Default',
  'detail.col.note': 'Note',
  'detail.section.indexes': 'Indexes',
  'detail.section.refs_out': 'References out',
  'detail.section.refs_in': 'References in',
  'detail.enum.kind': 'enum',
  'detail.section.values': 'Values',
  'detail.enum.not_referenced': 'Not referenced by any column.',
  'detail.section.used_by': 'Used by',
  'detail.flag.pk': 'PK',
  'detail.flag.fk': 'FK',
  'detail.flag.unique': 'UNIQUE',
  'detail.flag.auto': 'AUTO',
  'detail.flag.not_null': 'NOT NULL',

  // --- Diagram panel ---
  'diagram.toolbar.zoom_in.label': '+',
  'diagram.toolbar.zoom_in.title': 'Zoom in',
  'diagram.toolbar.zoom_out.label': '−',
  'diagram.toolbar.zoom_out.title': 'Zoom out',
  'diagram.toolbar.fit.title': 'Fit to screen',
  'diagram.toolbar.reset.label': '1:1',
  'diagram.toolbar.reset.title': 'Reset zoom',
  'diagram.toolbar.export_svg.label': 'SVG',
  'diagram.toolbar.export_svg.title': 'Export SVG',
  'diagram.toolbar.cols.toggle.label': 'FK only',
  'diagram.toolbar.cols.toggle.title': 'Show columns that are not part of any relationship',
  'diagram.toolbar.groups.toggle.title': 'Show group containers',
  'diagram.empty': 'No tables to draw.',
  'diagram.export.filename': 'diagram.svg',

  // --- App shell ---
  'app.file_button.title': 'Open .dbml file',
  'app.file_button.label': 'Open',
  'app.view.structure': 'Structure',
  'app.view.detail.table': 'Table',
  'app.view.detail.enum': 'Enum',
  'app.view.diagram': 'Diagram',
  'app.samples.label': 'Samples:',
  'app.file_dropdown.recent': 'Recent',
  'app.file_dropdown.samples': 'Samples',
  'app.theme.switch_to_light': 'Switch to light theme',
  'app.theme.switch_to_dark': 'Switch to dark theme',
  // The {extension} placeholder renders as a <code> element in the app shell.
  'app.dropzone.prompt': 'Drop a {extension} file here or click to browse.',
  'app.dropzone.hint': 'Or load a sample from the dropdown next to Open.',
  'app.previous_file': '(previous)',
  'app.error.load_url': "Couldn't load {label}: {message}",
  'app.error.parse.title': "Couldn't parse this DBML",
  'app.error.parse.close': 'Close',

  // --- Settings dropdown ---
  'app.settings.open': 'Settings',
  'app.settings.theme.light': 'Light',
  'app.settings.theme.dark': 'Dark',
  'app.settings.language.label': 'Language',
  'app.settings.font.mono': 'Mono',
  'app.settings.font.proportional': 'Sans',
  'app.settings.github': 'GitHub',
  'app.settings.github.title': 'View source on GitHub',
} as const;
